import React from 'react';

import Button, { ButtonGroup } from '@atlaskit/button';

import { useProjectContextValue } from '@qality/common-components/src/lib/QAlityPageConfiguration';
import { LoadingButtonWithTooltip } from '@qality/common-components/src/molecules/LoadingButtonWithTooltip';

import { useTestCaseRepositoryFoldersContext } from '../../../../TestCaseRepositoryFoldersProvider';
import { useTestCaseRepositoryIssuesContext } from '../../../../TestCaseRepositoryIssuesProvider';
import { ALL_TEST_CASES } from '../../../../TestCaseRepositoryPage.const';
import {
  ActionsWrapperStyled,
  ContainerStyled,
  MessageStyled,
} from './EmptyFolder.styled';

const openDocumentationPage = () => {
  window.open('https://soldevelo.atlassian.net/l/cp/DR711qyK', '_blank');
};

export function EmptyFolder(): JSX.Element {
  const { currentFolder, openAllTestCases } =
    useTestCaseRepositoryFoldersContext();
  const { createTestCases } = useTestCaseRepositoryIssuesContext();

  const project = useProjectContextValue();

  const handleCreateTestCases = () => {
    createTestCases(project);
  };

  const isInFolderAndCannotEditFolder = currentFolder && !currentFolder.canEdit;

  return (
    <ContainerStyled>
      <h3>Add Test Cases to this folder</h3>
      <MessageStyled>
        You can add or create new Test Cases in this folder or browse them in
        the “{ALL_TEST_CASES}” tab.
      </MessageStyled>
      <ActionsWrapperStyled>
        <ButtonGroup>
          <LoadingButtonWithTooltip
            loadingButtonProps={{
              appearance: 'primary',
              onClick: handleCreateTestCases,
              isDisabled: isInFolderAndCannotEditFolder,
            }}
            tooltipProps={{
              content:
                isInFolderAndCannotEditFolder &&
                "You don't have permission to add test cases to this folder.",
            }}
          >
            Create Test Case in this Folder
          </LoadingButtonWithTooltip>
          <Button onClick={openAllTestCases}>Browse Existing Test Cases</Button>
        </ButtonGroup>
        <Button appearance='link' onClick={openDocumentationPage}>
          Learn how
        </Button>
      </ActionsWrapperStyled>
    </ContainerStyled>
  );
}
